import styled, { css } from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import { fontSize } from 'modules/dashboard/DashboardSettings/DashboardSettings.styles'

export const ArchiveWrapper = styled.div`
  margin-top: 40px;
`

export const InfoText = styled.p`
  font-size: ${fontSize.small};
  color: ${colors.darkTeal};
  position: relative;
`

export const ArchivedClasses = styled.div`
  font-size: ${fontSize.small};
  color: ${colors.darkPurple};
  position: relative;
  margin-top: 35px;

  &:hover{
    cursor: pointer;
  }
`

export const Title = styled.h1`
  font-size: 22px;
  color: ${colors.darkPurple};
  margin-top: 0px;
  margin-bottom: 15px;
`

export const ArchivedClass = styled.div`
  margin: 10px 0;
`
